import React from 'react';

export default function AiModal({
  isAiModalOpen,
  setIsAiModalOpen,
  isAiLoading,
  aiEvaluationResult
}) {
  if (!isAiModalOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4 animate-fadeIn">
      <div className="bg-white rounded-3xl w-full max-w-sm overflow-hidden shadow-2xl flex flex-col max-h-[80vh]">
        <div className="p-5 border-b border-slate-100 flex items-center justify-between bg-blue-50">
          <h3 className="font-black text-blue-800 flex items-center gap-2">
            <span className="material-icons-round text-blue-600">smart_toy</span>
            AI 운동 평가
          </h3>
          <button onClick={() => setIsAiModalOpen(false)} className="text-slate-400 hover:text-slate-600 p-1">
            <span className="material-icons-round">close</span>
          </button>
        </div>
        
        <div className="p-6 overflow-y-auto flex-1">
          {isAiLoading ? (
            <div className="flex flex-col items-center justify-center py-10 space-y-4">
              <div className="w-10 h-10 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
              <p className="text-sm font-bold text-slate-500">운동 기록을 꼼꼼히 분석하고 있어요...</p>
            </div>
          ) : (
            <div className="text-sm text-slate-700 leading-relaxed whitespace-pre-wrap">
              {aiEvaluationResult}
            </div>
          )}
        </div>
        
        <div className="p-4 border-t border-slate-100 bg-slate-50">
          <button
            onClick={() => setIsAiModalOpen(false)}
            className="w-full py-3 bg-slate-800 text-white rounded-xl font-bold hover:bg-slate-700 transition-colors"
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
}